var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14 8.97046V6.97046C14 6.44003 13.7893 5.93132 13.4142 5.55625C13.0391 5.18117 12.5304 4.97046 12 4.97046H5C4.46957 4.97046 3.96086 5.18117 3.58579 5.55625C3.21071 5.93132 3 6.44003 3 6.97046V18.9705C3 19.5009 3.21071 20.0096 3.58579 20.3847C3.96086 20.7597 4.46957 20.9705 5 20.9705H12C12.5304 20.9705 13.0391 20.7597 13.4142 20.3847C13.7893 20.0096 14 19.5009 14 18.9705V16.9705M7 12.9705H21M21 12.9705L18 9.97046M21 12.9705L18 15.9705", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});